(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Add_Row_Spacing_Dialog = (function(superClass) {
    extend(Add_Row_Spacing_Dialog, superClass);

    function Add_Row_Spacing_Dialog() {
      return Add_Row_Spacing_Dialog.__super__.constructor.apply(this, arguments);
    }

    Add_Row_Spacing_Dialog.prototype.init = function() {
      this.classes = 'smaller_dialog';
      this.layoutUrl = 'backend/grower/machinery/load-layout-add-row-spacing';
      this.saveUrl = 'backend/grower/machinery/add-row-spacing';
      this.refreshNavHandler = false;
      return this.createDialog();
    };

    Add_Row_Spacing_Dialog.prototype.afterLoadLayout = function() {
      return this.openDialog();
    };

    Add_Row_Spacing_Dialog.prototype.submitAction = function() {
      return this.save('Saving...');
    };

    return Add_Row_Spacing_Dialog;

  })(DialogHandler);

}).call(this);
